import PropTypes from "prop-types";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import RedirectLink from "../../RedirectLink";
import ToolBar from "./ToolBar";
import MenuProducts from "./MenuProducts";
import logo from "../../../assets/images/rubk-short-logo.png";
import { ProfileStore } from "store";

const TitleProduct = "Rubk Faturamento";

const useStyles = makeStyles((theme) => ({
  header_wrapper: {
    height: "min-content",
  },
  header_main: {
    backgroundColor: theme.palette.header,
    minHeight: 64,
    padding: theme.spacing(0, 6),
  },
  header_primary: {
    backgroundColor: theme.palette.primary.main,
    minHeight: 32,
    padding: theme.spacing(0, 1),
  },
  logo_label: {
    color: theme.palette.white,
    fontFamily: "Orbitron",
    fontWeight: 900,
    fontSize: "1.2rem",
    fontStyle: "normal",
    letterSpacing: "0.2px",
    textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  logo_img: {
    height: "15px",
    marginRight: theme.spacing(2),
  },
  title: {
    color: theme.palette.white,
    fontWeight: 500,
    fontSize: "1.1rem",
    letterSpacing: "0.2px",
    paddingTop: "0.1rem",
  },
}));

const TopBarMain = ({ classes }) => (
  <RedirectLink to="home">
    <Typography
      className={classes.logo_label}
      component="h1"
      onClick={() => ProfileStore.closeProfileLayer()}
    >
      {TitleProduct}
    </Typography>
  </RedirectLink>
);

const TopBarPrimary = ({ classes, title }) => (
  <RedirectLink to="home">
    <img className={classes.logo_img} src={logo} alt="Logo" />
    <Typography className={classes.title} component="h1">
      {title || TitleProduct}
    </Typography>
  </RedirectLink>
);

type IProps = {
  title?: string;
  enableActions?: boolean;
  variant: string;
};

const Header = ({ title, enableActions, variant }: IProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      className={[classes.header_wrapper, classes["header_" + variant]].join(
        " "
      )}
    >
      <Grid container item xs md alignItems="center">
        <MenuProducts />
        {variant === "primary" ? (
          <TopBarPrimary classes={classes} title={title} />
        ) : (
          <TopBarMain classes={classes} />
        )}
      </Grid>
      {enableActions && <ToolBar onlyHelpAction={variant !== "main"} />}
    </Grid>
  );
};

Header.propTypes = {
  /** Título da página. */
  title: PropTypes.string,
  /** Habilitar barra de ações. */
  enableActions: PropTypes.bool,
  /** Define o estilo da TopBar */
  variant: PropTypes.string.isRequired,
};

Header.defaultProps = {
  variant: "main",
};

export default Header;
